enum VodModuleTypeEnum  {
  Program = 0,
  CustomCategory = 1,
  Entity = 2,
}
export default Object.freeze(VodModuleTypeEnum);
